// Уведомление, пришедшее, пока приложение на экране: Android его сам не покажет,
// и человек у открытого приложения пропустил бы ровно то, ради чего включал push.
// Последнее — одно: новое заменяет старое, стопка из тостов перекрыла бы экран.

export type ForegroundPush = { readonly title: string; readonly body: string };

let current: ForegroundPush | null = null;
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) listener();
}

export function showForegroundPush(push: ForegroundPush): void {
  current = push;
  notify();
}

export function dismissForegroundPush(): void {
  current = null;
  notify();
}

export function currentForegroundPush(): ForegroundPush | null {
  return current;
}

export function subscribeForegroundPush(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
